import { useEffect } from 'react';

const PAGE_TITLES: Record<string, string> = {
  '/': 'Home | TipsterChat',
  '/dashboard': 'Dashboard | TipsterChat',
  '/pc': 'Publicar Tip | TipsterChat',
  '/my-bets': 'Mis Tips | TipsterChat',
  '/sales': 'Ventas | TipsterChat',
  '/balance': 'Retirar | TipsterChat',
  '/user-stats': 'Estadísticas | TipsterChat',
  '/login': 'Dashboard TipsterChat',
  '/register': 'Registro | TipsterChat',
  '/recover-password': 'Recuperar Contraseña | TipsterChat',
  '/reset-password': 'Restablecer Contraseña | TipsterChat',
  '/verify': 'Verificar Email | TipsterChat',
};

export const usePageTitle = (pathname: string) => {
  useEffect(() => {
    const title = PAGE_TITLES[pathname] || 'TipsterChat';
    document.title = title;
  }, [pathname]);
};
